import { useState } from "react";
import { useUserViewModel } from "../../viewmodels/user/userViewModel";
import DashboardLayout from "../../components/layout/DashboardLayout";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import CompanySelector from "../../components/common/CompanySelector";

const CreateUser = () => {
  const navigate = useNavigate();
  const { createUser, roles } = useUserViewModel();

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState<any>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    roleId: "",
    userTenants: [],
  });

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    //  Password validation
    if (form.password.length < 4) {
      return toast.error("Password must exceed 4 characters");
    }

    if (form.password !== form.confirmPassword) {
      return toast.error("Passwords do not match");
    }

    if (!form.roleId) {
      return toast.error("Please select a role");
    }

    if (form.userTenants.length === 0) {
      return toast.error("Select at least one company");
    }

    setLoading(true);

    try {
      await createUser(form);
      toast.success("User created successfully");
      navigate("/users");
    } catch (err: any) {
      toast.error(err.message || "Failed to create user");
    }

    setLoading(false);
  };

  return (
    <DashboardLayout>
      <div className="p-4 md:p-6 max-w-4xl mx-auto">

        {/* BREADCRUMB */}
        <div className="text-sm text-gray-500 mb-3">
          Dashboard / Users / Create
        </div>

        {/* HEADER */}
        <h2 className="text-xl font-semibold mb-6">
          Create User
        </h2>

        {/* FORM */}
        <form
          onSubmit={handleSubmit}
          className="bg-white shadow rounded-xl p-6 space-y-6"
        >

          {/* GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            {/* FIRST NAME */}
            <div>
              <label className="text-sm font-medium">
                First Name *
              </label>
              <input
                  required
                  className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter first name"
                  onChange={(e) =>
                    setForm({ ...form, firstName: e.target.value })
                  }
                />
            </div>

            {/* LAST NAME */}
            <div>
              <label className="text-sm font-medium">
                Last Name *
              </label>
              <input
                required
                className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
                placeholder="Enter last name"
                onChange={(e) =>
                  setForm({ ...form, lastName: e.target.value })
                }
              />
            </div>

            {/* EMAIL */}
            <div>
              <label className="text-sm font-medium">
                Email *
              </label>
              <input
                type="email"
                required
                placeholder="example@email.com"
                className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
                onChange={(e) =>
                  setForm({ ...form, email: e.target.value })
                }
              />
            </div>

            {/* PHONE */}
            <div>
              <label className="text-sm font-medium">
                Phone *
              </label>

              <input
                type="tel"
                inputMode="numeric"
                className="w-full border px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500"
                value={form.phoneNumber || ""}
                onChange={(e) => {

                  let numbers =
                    e.target.value.replace(
                      /\D/g,
                      ""
                    );


                  setForm({
                    ...form,
                    phoneNumber: numbers,
                  });

                }}
              />
            </div>

            {/* PASSWORD */}
            <div>
              <label className="text-sm font-medium">
                Password *
              </label>
              <input
                type="password"
                required
                placeholder="Enter password"
                className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
                onChange={(e) =>
                  setForm({ ...form, password: e.target.value })
                }
              />
            </div>

            {/* CONFIRM PASSWORD */}
            <div>
              <label className="text-sm font-medium">
                Confirm Password *
              </label>
              <input
                type="password"
                required
                placeholder="Confirm password"
                className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
                onChange={(e) =>
                  setForm({
                    ...form,
                    confirmPassword: e.target.value,
                  })
                }
              />
            </div>

            {/* ROLE */}
            <div className="md:col-span-2">
              <label className="text-sm font-medium">
                Role *
              </label>
              <select
                className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
                value={form.roleId}
                onChange={(e) =>
                  setForm({ ...form, roleId: e.target.value })
                }
              >
                <option value="">Select Role</option>
                {roles.map((r: any) => (
                  <option key={r.id} value={r.id}>
                    {r.name}
                  </option>
                ))}
              </select>
            </div>

            {/* COMPANY SELECTOR */}
            <div className="md:col-span-2">
              <label className="text-sm font-medium">
                Companies*
              </label>

              <CompanySelector
                value={form.userTenants}
                onChange={(val: any) =>
                  setForm({ ...form, userTenants: val })
                }
              />
            </div>

          </div>

          {/* ACTION BUTTONS */}
          <div className="flex justify-end gap-3 pt-4 border-t">

            <button
              type="button"
              onClick={() => navigate("/users")}
              className="px-4 py-2 border rounded-lg"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow"
            >
              {loading ? "Saving..." : "Save User"}
            </button>
          </div>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default CreateUser;